async function addStockMessaging () {
  if (window.theme.settings.template !== 'product.supadu') return
  try {
    if (!window.theme.productData || !window.theme.productData.variants || !window.theme.productData.variants.length) return
    const productFormInner = document.querySelector('.product-form__inner')
    if (!productFormInner) return
    const variant = window.theme.productData.variants.find(variant => variant.title === 'Default Title')
    if (!variant || !variant.sku) return
    const requestUrl = window.theme.settings.environment === 'staging'
      ? `https://umc4lmsm52.execute-api.us-east-1.amazonaws.com/staging/add-to-cart?action=availability&isbn=${variant.sku}&client=indiepubs-us`
      // live req url to go here
      : ''
    const response = await fetch(requestUrl)
    const responseJSON = await response.json()
    if (responseJSON.msg) {
      const stockMessage = `
        <div class="indiepubs-stock-message">
          <span>
            <strong>${responseJSON.msg}</strong>
          </span>
        </div>
      `
      productFormInner.insertAdjacentHTML('afterend', stockMessage)
    }
    if (!responseJSON.show) {
      productFormInner.style.display = 'none'
    }
  } catch (e) {
    // console.log(e)
  }
}

function customFunctions () {
  addStockMessaging()
}

module.exports = { customFunctions }
